import { createBrowserRouter } from 'react-router-dom';
import { HomePage } from '~/routes/home';
import { NotesPage } from '~/routes/notes';

/**
 * Declarative-режим react-router v7.
 * Добавить страницу: создай компонент в src/routes/foo.tsx, добавь объект сюда.
 */
export const router = createBrowserRouter([
  { path: '/', element: <HomePage /> },
  { path: '/notes', element: <NotesPage /> },
]);
